const button1 = require('../assets/sounds/button1.mp3');

const buttonPressAudio = new Audio(button1);

export function playButtonSound() {
  buttonPressAudio.play();
}